import { Link } from 'react-router-dom';

export function PrivacyPage() {
  return (
    <div className="min-h-screen bg-[#11111b] text-[#cdd6f4]">
      <div className="max-w-3xl mx-auto px-6 py-10">
        <h1 className="text-3xl font-bold text-white mb-6">Privacy Policy</h1>
        <p className="text-sm text-[#a6adc8] mb-8">Last updated: February 7, 2026</p>

        <div className="space-y-5 text-sm leading-7">
          <p className="rounded-md border border-amber-400/30 bg-amber-500/10 px-3 py-2 text-amber-200">
            Test Mode Notice: UI Grace operates in test (beta) mode. Data retention, processing behavior, and feature
            scope may change during testing.
          </p>
          <p>
            We process basic account data (for example email and profile identifiers) to provide authentication,
            project access, and technical operation of the service.
          </p>
          <p>
            User-provided AI API keys are transmitted via HTTPS and stored on the server in encrypted form. Keys are
            not stored in browser local storage and are used only for authorized generation requests.
          </p>
          <p>
            We keep operational logs and technical telemetry required for reliability, abuse prevention, and security.
            We do not intentionally use your API key for unrelated purposes.
          </p>
          <p>
            Third-party providers (for example Firebase and Google AI services) process data according to their own
            terms and policies. You are responsible for complying with those terms.
          </p>
          <p>
            You may revoke or replace your API key at any time. We may update this Policy; continued use after updates
            means acceptance of the revised version.
          </p>
        </div>

        <div className="mt-10">
          <Link to="/login" className="text-[#89b4fa] hover:underline text-sm">
            Back to Login
          </Link>
        </div>
      </div>
    </div>
  );
}
